/*
 * Copyright (c) 2024. Haodong JU
 */

import { VTextField } from 'vuetify/lib/components'
import IKUtils from 'innerken-js-utils'
import i18n from '@/i18n'

export const formField = {
  name: '',
  key: '',
  component: VTextField,
  required: true,
  default: null,
  hint: '',
  componentProps: {
    rules: [],
    outlined: true,
    hideDetails: false,
    dense: true
  }

}
const ruleNoEmpty = (v) => {
  return v === false || v === 0 || !!v || i18n.t('cantBeEmpty')
}

/**
 * @param {name:string,key:string,component:object,required:boolean?} schema
 * @return {name:string,key:string,component:object}
 */
export function mapSchemaToField (schema) {
  const tmp = Object.assign({}, formField, IKUtils.deepCopy(schema))
  if (!tmp.name) {
    tmp.name = tmp.key
  }
  tmp.componentProps = Object.assign({},
    formField.componentProps,
    tmp.componentProps,
    { placeholder: i18n.t('PleaseInputTheX', { configItem: i18n.t(tmp.name) }) })
  // Ensure rules is a standalone array (avoid mutating shared default)
  const existingRules = (tmp.componentProps && Array.isArray(tmp.componentProps.rules)) ? tmp.componentProps.rules : []
  tmp.componentProps.rules = [...existingRules]
  tmp.required = tmp.required ?? true
  if (tmp.required) {
    // Add non-empty rule if not already present
    if (!tmp.componentProps.rules.includes(ruleNoEmpty)) {
      tmp.componentProps.rules.push(ruleNoEmpty)
    }
  }
  return tmp
}
